import { useCallback } from 'react';
import { useUt } from '../context/UtFlagContext';
import { isUploadedPhoto } from '../components/ut/profile/photo';

/**
 * The picture to show for a player's avatar_svg. The old (non-UT) UI shows
 * generated avatars only: uploaded photos and kit portraits are a UT feature
 * (owner, 2 Oct 2026), so it gets null for those (callers fall back to their
 * default avatar or initials). Components shared with UT pages keep photos there.
 */
export function useAvatarSrc() {
  const { enabled } = useUt();
  return useCallback((src: string | null | undefined): string | null => (!enabled && isUploadedPhoto(src) ? null : src ?? null), [enabled]);
}
